export default __webpack_public_path__ + "static/media/image-study-board-2-m@2x.c59f37e1.webp";